<div class="left-sidebar">
  <div class="profile card">
    <div class="profile__top">
      <img
        class="profile__top-image"
        [src]="profileBackgroundImageUrl"
        alt=""
      />
      <div class="profile__overlay"></div>
      <app-profile-avatar
        class="profile__avatar"
        [profileId]="profile?.id"
      ></app-profile-avatar>
    </div>
    <div class="profile__info">
      <h3>{{ profile | profileDisplayName }}</h3>
      @if(userInstance?.countryName) {
      <span class="profile__info-country">{{ userInstance?.countryName }}</span>
      }
      <div class="profile__info-specialty">
        <span>
          {{ userInstance?.roleLevel?.name || 'No role level selected' }}
        </span>
        @if (userInstance?.specialty?.name) {
        <span> | {{ userInstance?.specialty?.name }} </span>
        }
      </div>

      <app-profile-completeness
        class="profile__completeness"
        [profile]="profile"
        [variant]="'compact'"
        [showAction]="true"
        (action)="goToProfile()"
      ></app-profile-completeness>
    </div>
    <!-- <div class="profile__gamification">
      <div class="profile__gamification-bar-container">
        <span class="profile__gamification-bar-title"> {{ 'Level 3' }}</span>
        <div class="profile__gamification-bar">
          <div
            [ngStyle]="{ width: '30%' }"
            class="profile__gamification-load"
          ></div>
        </div>
      </div>
      <div class="profile__gamification-items">
        <div class="profile__gamification-item">
          <div class="profile__gamification-icon-container">
            <fa-icon [icon]="['fas', 'bolt']" class="profile__gamification-icon profile__gamification-icon--yellow"
             
            ></fa-icon>
          </div>
          <div class="profile__gamification-item-info">
            <span class="profile__gamification-item-number"> {{ '3' }} </span>
            <span class="profile__gamification-item-description">
              {{ 'Days streaks' }}</span
            >
          </div>
        </div>

        <div class="profile__gamification-item">
          <div class="profile__gamification-icon-container">
            <fa-icon [icon]="['fas', 'users']" class="profile__gamification-icon profile__gamification-icon--blue"
             
            ></fa-icon>
          </div>
          <div class="profile__gamification-item-info">
            <span class="profile__gamification-item-number"> {{ '8' }}</span>
            <span class="profile__gamification-item-description">{{
              'Collaboration'
            }}</span>
          </div>
        </div>
      </div>
    </div> -->
  </div>

  @if(loadingGroups || collaborationGroups.length > 0) {
  <div class="widget card">
    <app-widget-title
      [titleKey]="hasMyGroups ? 'LEFT_SIDEBAR.MY_GROUPS' : 'GROUP.TITLE_LIST'"
      [iconClass]="'fa-regular fa-users'"
    ></app-widget-title>
    <button
      (click)="openCreateGroupModal()"
      class="btn btn--sm btn--full-width btn--outline"
    >
      <span> + {{ 'FEED.NEW_GROUP' | translate }} </span>
    </button>

    @if(loadingGroups) {

    <div class="widget__list">
      @for (_ of [1, 2, 3]; track _) {
<div
        [medSkeletonLoading]="true"
        style="width: 100%; height: 50px"
       
      ></div>
}
    </div>

    } @else {
    <div class="widget__list">
      @for (item of collaborationGroups; track item) {
<app-widget-item
        [item]="item"
       
      ></app-widget-item>
}
    </div>
    }
  </div>
  } @if(loadingEvents || liveStreamings.length > 0) {
  <div class="widget card">
    <app-widget-title
      [titleKey]="
        hasMyEvents ? 'LEFT_SIDEBAR.MY_EVENTS' : 'FEED.UPCOMING_LIVE_STREAMING'
      "
      [iconClass]="'fa-regular fa-calendar-days'"
    ></app-widget-title>

    @if(loadingEvents) {

    <div class="widget__list">
      @for (_ of [1, 2, 3]; track _) {
<div
        [medSkeletonLoading]="true"
        style="width: 100%; height: 50px"
       
      ></div>
}
    </div>

    } @else {
    <div class="widget__list">
      @for (item of liveStreamings; track item) {
<app-widget-item
        [item]="item"
       
      ></app-widget-item>
}
    </div>
    }
  </div>
  }
</div>
